module.exports = __webpack_public_path__ + "img/hederkorzina.bbf840c8.svg";